import { Menu, MenuItem } from "@mui/material";
import styled from "styled-components";

export const ProfileMenuWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledMenu = styled(Menu)`
    & .MuiPaper-root {
        width: 184px;
        padding: 6px 0px;
        border-radius: 12px;
        border-radius: 8px;
        box-sizing: border-box;
        box-shadow: none;
        border: 1px solid ${'#D5D5D5'};
    }

    & .MuiList-root {
        padding: 0px;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
`;

export const CustomMenuItem = styled(MenuItem)`
    && {
        padding: 6px 12px;
        background: ${(props) => props.className === "unread" && "#f7f7f7"};
        font-family: "Noto Sans";
        width: 100%;
        display: flex;
        gap: 30px;

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const LinkTab = styled.a`
    text-decoration: none;
    color: inherit;
`;
